import { TextField } from "@mui/material";
import "../../assets/style/PayMethod.css";

export default function BankAccountForm(props) {
  const {
    bankName,
    setBankName,
    accountNumber,
    setAccountNumber,
    notes,
    setNotes,
  } = props;
  
  return (
    <div className="payment-form-fields">
      <TextField
        label="Bank Name"
        variant="outlined"
        fullWidth
        className="custom-textfield"
        value={bankName}
        onChange={(e) => setBankName(e.target.value)}
      />
      <TextField
        label="Account Number"
        variant="outlined"
        fullWidth
        className="custom-textfield"
        value={accountNumber}
        onChange={(e) => setAccountNumber(e.target.value)}
      />
      <TextField
        label="Notes"
        variant="outlined"
        fullWidth
        multiline
        rows={4}
        className="custom-textfield"
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
      />
    </div>
  );
}
